import React from "react";
import "./Finish.css";
import { useTranslation } from "react-i18next";


interface FinishProps {
  message?: string;
  img?: string;
}

const Finish: React.FC<FinishProps> = ({ message = "text", img = "/img/basezero_logo.png" }: FinishProps): React.JSX.Element => {

  const { t } = useTranslation(); // Use useTranslation hook


  return (
    <div className="finish">
      <div className="image-container">
        <img className="finish-gif" alt="Finish" src={img} height={551} width={538} />
      </div>
      <div className="text">{t(`finish.${message}`)}</div>
    </div>
  );
};

export default Finish;